import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './index.css';

import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from "./components/ThemeContext";

import UnitConverter from './components/UnitConverter';
import ImageTools from './components/ImageTools';
import Footer from './components/Footer';
import Header from './components/Header';
import Home from './components/Home';
import ColorTools from './components/ColorTools';
import TextTools from './components/TextTools';
import CodeTools from './components/CodeTools';
import JsonValidator from './components/JsonValidator';
import RegexTester from './components/RegexTester';
import Base64Tool from './components/Base64Tool';
import HashGenerator from './components/HashGenerator';
import JWTDecoder from './components/JWTDecoder';
import ImageCropTool from './components/ImageCropTool';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import Contact from './components/Contact';
import BeautifyCodeGuide from './components/guides/BeautifyCodeGuide';
import Base64EncodingGuide from './components/guides/Base64EncodingGuide';
import CleanTextTips from './components/guides/CleanTextTips';
import WordCharCounterGuide from './components/guides/WordCharCounterGuide';
import RegexSearchReplaceGuide from './components/guides/RegexSearchReplaceGuide';
import HtmlToMarkdownGuide from './components/guides/HtmlToMarkdownGuide';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider>
      <Router>
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/unitconverter" element={<UnitConverter />} />
              <Route path="/imagetools" element={<ImageTools />} />
              <Route path="/colortools" element={<ColorTools />} />
              <Route path="/texttools" element={<TextTools />} />
              <Route path="/codetools" element={<CodeTools />} />
              <Route path="/jsonvalidator" element={<JsonValidator />} />
              <Route path="/regextester" element={<RegexTester />} />
              <Route path="/base64" element={<Base64Tool />} />
              <Route path="/hashgenerator" element={<HashGenerator />} />
              <Route path="/jwtdecoder" element={<JWTDecoder />} />
              <Route path="/imagecrop" element={<ImageCropTool />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/guides/beautify-code-online" element={<BeautifyCodeGuide />} />
              <Route path="/guides/base64-encoding-guide" element={<Base64EncodingGuide />} />
              <Route path="/guides/clean-text-tips" element={<CleanTextTips />} />
              <Route path="/guides/word-char-counter" element={<WordCharCounterGuide />} />
              <Route path="/guides/regex-search-replace" element={<RegexSearchReplaceGuide />} />
              <Route path="/guides/html-to-markdown" element={<HtmlToMarkdownGuide />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
);

// Performance reporting
reportWebVitals();
